import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { store } from "../reducer/Store";
import ApiService from "../services/ApiService";
import { ToastContainer } from "react-toastify";
import Utils from "../services/Utils";
import ResetPasswordModal from "../components/login/ResetPasswordModal";
import NewPasswordModal from "../components/login/NewPasswordModal";
import FormLogin from "../components/login/FormLogin";
const Login = () => {
  const { dispatch, state } = React.useContext(store);
  const location = useLocation();
  const fromLastLocation = location.state && location.state.from.pathname;
  const [username, setUsername] = React.useState("");
  const [pwd, setPwd] = React.useState("");
  const [pwdConfirm, setPwdConfirm] = React.useState("");
  const [token, setToken] = React.useState("");
  const [showResetPassword, setShowResetPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [errorResetPassword, setErrorResetPassword] = React.useState("");
  React.useState("");
  const [successMessage, setSuccessMessage] = React.useState("");
  const [loader, setLoader] = React.useState(false);
  const [loader2, setLoader2] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [passwordShow, setPasswordShow] = React.useState(false);

  const handlePasswordShow = () => setPasswordShow(!passwordShow);

  /**
   * Fonction pour gérer la connexion de l'utilisateur.
   * Cette fonction envoie une requête API pour se connecter à l'aide du nom d'utilisateur et du mot de passe fournis.
   * Si la connexion réussit, elle stocke le token d'authentification, les détails de l'utilisateur et son rôle dans le local storage.
   * Si l'utilisateur est associé à plusieurs marques, les détails de ces marques sont également stockés dans le local storage.
   * Cette fonction utilise le hook useState pour mettre à jour l'état du loader en cours d'exécution et afficher un message d'erreur si la connexion échoue.
   * @param {Event} e - L'événement de click du bouton de connexion.
   * @param { String } username - Email pour se connecter.
   * @param { String } pwd - Mot de passe pour se connecter.
   * @returns {void}
   */
  const connect = (e) => {
    e.preventDefault();
    setLoader(true);

    ApiService.request({ email: username, password: pwd }, "login", "post")
      .then(function (response) {
        setLoader(false);
        //dispatch({ type: "SET_USER", payload: response.data });
        // On stocke dans le localStorage toutes les données dont nous avons besoin ici
        localStorage.setItem("token", response.data.token);
        localStorage.setItem(
          "user",
          JSON.stringify([response.data.name, response.data.email])
        );
        localStorage.setItem("userId", JSON.stringify(response.data.id));
        localStorage.setItem("user_role", response.data.role);
        if (response.data.brand_users) {
          localStorage.setItem(
            "brands",
            JSON.stringify(response.data.brand_users)
          );
        }
        dispatch({ type: "SET_AUTH", payload: true });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        setLoader(false);
        console.log(error);
        setErrorMessage(
          "Impossible de se connecter, vérifier votre mot de passe ou votre adresse email."
        );
      });
  };

  /**
   * Fonction pour réinitialiser le mot de passe utilisateur.
   * Cette fonction envoie une requête API pour réinitialiser le mot de passe en utilisant l'adresse e-mail fournie.
   * Si l'adresse e-mail est valide, l'utilisateur recevra un e-mail de réinitialisation du mot de passe.
   * Cette fonction utilise le hook useState pour mettre à jour l'état du loader en cours d'exécution et afficher un message d'erreur si la réinitialisation du mot de passe échoue.
   * @param { String } username - Email pour réinitialiser le mot de passe.
   * @returns {void}
   */
  const forgotPassword = () => {
    setErrorMessage("");
    setSuccessMessage("");
    setErrorResetPassword("");
    setLoader2(true);

    ApiService.request({ email: username }, "password-reset/email", "post")
      .then(function () {
        setLoader2(false);
        setSuccessMessage(
          "Vous allez bientôt recevoir un e-mail de notre part."
        );
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        setLoader2(false);
        console.log(error);
        if (
          error.response.data.message.includes("The given data was invalid")
        ) {
          setErrorResetPassword("L'email n'est pas valide.");
        } else if (
          error.response.data.message.includes("email could not be send")
        ) {
          setErrorResetPassword(
            "L'email n'a pas pu être envoyé, veuillez ré-essayer plus tard ou contacter votre administrateur."
          );
        } else {
          setErrorResetPassword("Une erreur est survenue.");
        }
      });
  };

  /**
   * Fonction pour réinitialiser le mot de passe utilisateur.
   * Cette fonction envoie une requête API pour réinitialiser le mot de passe en utilisant le token fourni, le nouveau mot de passe et la confirmation de mot de passe.
   * Si la réinitialisation du mot de passe est réussie, la fonction ferme la fenêtre modale de réinitialisation de mot de passe, met à jour l'état de l'application et affiche un message de réussite.
   * Cette fonction utilise le hook useState pour mettre à jour l'état du loader en cours d'exécution et afficher un message d'erreur si la réinitialisation du mot de passe échoue.
   * @param { String } pwd - Nouveau mot de passe.
   * @param { String } pwdConfirm - Nouveau mot de passe.
   * @param { String } token - Token pour pouvoir réinitialiser son mot de passe.
   * @returns {void}
   */
  const resetPassword = () => {
    setErrorMessage("");
    setSuccessMessage("");
    setErrorResetPassword("");
    setLoader2(true);

    ApiService.request(
      { token: token, password: pwd, confirm_password: pwdConfirm },
      "password-reset/change-password",
      "post"
    )
      .then(function () {
        setLoader2(false);
        handleClose();
        setPwd("");
        Utils.notifySuccess("Votre mot de passe a bien été mis à jour");
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        setLoader2(false);
        console.log(error);
        if (
          error.response.data.message ===
          "User password different from confirm_password."
        ) {
          setErrorResetPassword(
            "Les champs mot de passe et la confirmation de mot de passe doivent être identitques."
          );
        } else {
          setErrorResetPassword("Une erreur est survenue.");
        }
      });
  };

  /**
   * Vérifie si le token de réinitialisation de mot de passe est valide en envoyant une requête API avec le token fourni.
   * Si la vérification est réussie, la fonction met à jour l'état de l'application pour afficher le formulaire de saisie d'un nouveau mot de passe.
   * Cette fonction utilise le hook useState pour mettre à jour l'état de l'application en cas d'erreur lors de la vérification du token.
   * @param {string} tokenToReset - Le token de réinitialisation de mot de passe à vérifier.
   * @returns {void}
   */
  const checkToken = (tokenToReset) => {
    setErrorMessage("");
    setErrorResetPassword("");
    setSuccessMessage("");
    ApiService.request(
      { token: tokenToReset },
      "password-reset/check-token",
      "post"
    )
      .then(function (response) {
        // console.log(response.data);
        setToken(tokenToReset);
        setShowNewPassword(true);
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        console.log(error);
        //setErrorMessage("Token invalid.");
      });
  };

  const handleClose = () => {
    setShowResetPassword(false);
    setShowNewPassword(false);
    setErrorResetPassword("");
    setSuccessMessage("");
    setPwdConfirm("");
  };

  const [formData] = React.useState({
    pwd: pwd || "",
    pwdConfirm: pwdConfirm || "",
    email: username || "",
  });
  const [newFormData, setNewFormData] = React.useState({
    ...formData,
  });

  /**
   * Met à jour les données de formulaire lorsqu'un champ d'entrée est modifié.
   * Cette fonction est appelée à chaque fois qu'un champ de saisie de formulaire est modifié.
   * Elle récupère les valeurs saisies dans les champs et met à jour l'état de l'application en conséquence.
   * @param {object} e - L'objet événement représentant l'action de l'utilisateur.
   */
  const handleInputChange = (e) => {
    setNewFormData({
      ...newFormData,
      [e.target.name]: e.target.value,
    });
  };

  /**
   * Gère la fermeture de la fenêtre modale.
   * Cette fonction est appelée lorsqu'on souhaite fermer la fenêtre modale.
   * Elle vérifie si des changements ont été effectués dans le formulaire et affiche une boîte de dialogue de confirmation si c'est le cas.
   * Si l'utilisateur confirme, la fenêtre modale se ferme, sinon elle reste ouverte.
   */
  const handleModalHide = () => {
    var windowConfirm = false;
    if (JSON.stringify(formData) !== JSON.stringify(newFormData)) {
      windowConfirm = true;
    }
    if (windowConfirm) {
      if (
        window.confirm(
          "Vous avez effectué des changements, êtes vous sûr de vouloir quitter sans valider ?"
        )
      ) {
        handleClose();
      }
    } else {
      handleClose();
    }
  };
  React.useEffect(() => {
    const url = window.location.href;
    const contentAfterLogin = url.split("login/")[1];
    if (
      contentAfterLogin &&
      contentAfterLogin !== null &&
      contentAfterLogin !== ""
    ) {
      checkToken(contentAfterLogin);
    }
  }, []);
  return (
    <>
      <ToastContainer />
      {state.isAuth ? (
        fromLastLocation ? (
          <Navigate to={fromLastLocation} />
        ) : (
          <Navigate to="/client" />
        )
      ) : (
        <>
          {showResetPassword && (
            <ResetPasswordModal
              handleClose={handleClose}
              showResetPassword={showResetPassword}
              forgotPassword={forgotPassword}
              loader2={loader2}
              username={username}
              handleInputChange={handleInputChange}
              setUsername={setUsername}
              errorResetPassword={errorResetPassword}
              successMessage={successMessage}
              handleModalHide={handleModalHide}
            />
          )}
          {showNewPassword && (
            <NewPasswordModal
              handleClose={handleClose}
              showNewPassword={showNewPassword}
              resetPassword={resetPassword}
              loader2={loader2}
              passwordShow={passwordShow}
              pwd={pwd}
              setPwd={setPwd}
              handlePasswordShow={handlePasswordShow}
              pwdConfirm={pwdConfirm}
              setPwdConfirm={setPwdConfirm}
              handleInputChange={handleInputChange}
              errorResetPassword={errorResetPassword}
              successMessage={successMessage}
              handleModalHide={handleModalHide}
            />
          )}
          <div className="container-fluid min-vh-100">
            <div className="row min-vh-100">
              <div className="col-md-6 align-self-center login-bg min-vh-100 d-none d-lg-block"></div>
              <div className="col-md-6 align-self-center">
                <div className="column">
                  <p className="text-center">
                    <img
                      src="../assets/img/logo/logo-fabre.svg"
                      alt="Pierre Fabre"
                      width="75"
                      height="75"
                    />
                  </p>
                  <h1 className="loginTitle fw700 text-center blue">
                    TRADE MARKETING
                  </h1>
                </div>
                <div className="container-fluid w-50">
                  <FormLogin
                    connect={connect}
                    passwordShow={passwordShow}
                    pwd={pwd}
                    setPwd={setPwd}
                    username={username}
                    setUsername={setUsername}
                    handlePasswordShow={handlePasswordShow}
                    loader={loader}
                    errorMessage={errorMessage}
                    setShowResetPassword={setShowResetPassword}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default Login;
